const appDataMockup = {
    odUserInfo: {
        username: "mackt",
        name: "Thomas",
        surname: "Mockup",
        mail: "mack.thomas@rummelsberger.net",
        odDeskPreferences: {
            theme: "theme-default",
            favorites: [
                "cn=odapp_sap_manager_desktop,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                "cn=odapp_meinrummelsberg,ou=ui,ou=groups,dc=open-diakonie,dc=de"
            ]
        },
        apps: [
            {
                cn: "odapp_grp_admin",
                dn: "cn=odapp_grp_admin,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Administration",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "200",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "nc_admin",
                        dn: "cn=nc_admin,ou=netcloud,ou=groups,dc=open-diakonie,dc=de",
                        description: "cloud.rummelsberger.net Admin",
                        odAppTitle: "cloud.rummelsberger.net",
                        odAppType: "Link",
                        odAppIcon: "fa-light fa-cloud-rainbow",
                        odAppIconType: "font",
                        odAppSubTitle: "Admin",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_admin,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: 999
                    },
                    {
                        cn: "odapp_admin_rudikey",
                        dn: "cn=odapp_admin_rudikey,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDi#Key Admin",
                        odAppTitle: "RuDi#Key",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-key",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "Zugriff auf RuDi#Key nur aus dem Rummelsberger Netz möglich",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://auth.open-diakonie.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_admin,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "10"
                    }
                ]
            },
            {
                cn: "odapp_grp_kommunikation",
                dn: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Kommunikation",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "10",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "user",
                        dn: "cn=user,ou=rudichat,ou=groups,dc=open-diakonie,dc=de",
                        description: "RuDi.Chat allgemeiner Nutzer",
                        odAppTitle: "RuDi#Chat",
                        odAppType: "Link",
                        odAppIcon: "https://open-diakonie.de/cdn/images/chat_Symbol.svg",
                        odAppIconType: "file",
                        odAppSubTitle: "",
                        odAppDescription: "Chat der Rummelsberger Diakonie. \r\nIntern wie extern nutzbar.",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://chat.open-diakonie.de",
                        odAppHelpLocation: "https://meinrummelsberg/faq/8797594",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "10"
                    },
                    {
                        cn: "odapp_time",
                        dn: "cn=odapp_time,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDi#Time",
                        odAppTitle: "RuDi#Time",
                        odAppType: "link",
                        odAppIcon: "https://open-diakonie.de/cdn/images/time_Symbol.svg",
                        odAppIconType: "file",
                        odAppSubTitle: "",
                        odAppDescription: "Terminplanung und Koordination mit internen und externen, vergleichbar Doodle. ",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://open-diakonie.de/termine",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "40"
                    },
                    {
                        cn: "odapp_live",
                        dn: "cn=odapp_live,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDi#live",
                        odAppTitle: "RuDi#Live",
                        odAppType: "link",
                        odAppIcon: "https://open-diakonie.de/cdn/images/live_Symbol.svg",
                        odAppIconType: "file",
                        odAppSubTitle: "",
                        odAppDescription: "Videokonferenzen ohne vorherige Anmeldung.",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://live.open-diakonie.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "30"
                    },
                    {
                        cn: "odapp_bbb_join",
                        dn: "cn=odapp_bbb_join,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDi#bbb",
                        odAppTitle: "RuDi#BBB",
                        odAppType: "bbb-join",
                        odAppIcon: "https://open-diakonie.de/cdn/images/bbb_Symbol.svg",
                        odAppIconType: "file",
                        odAppSubTitle: "",
                        odAppDescription: "Einem BigBlueButton-Raum beitreten.",
                        odAppSizeRow: "1",
                        odAppSizeCol: "1",
                        odAppLocation: "",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "50"
                    },
                    {
                        cn: "odapp_meinrummelsberg",
                        dn: "cn=odapp_meinrummelsberg,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App meinRummelsberg",
                        odAppTitle: "mein<wbr>Rummelsberg",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-globe",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://meinrummelsberg.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "10"
                    },
                    {
                        cn: "odapp_wlan_voucher",
                        dn: "cn=odapp_wlan_voucher,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDi#Net Voucher",
                        odAppTitle: "RuDi#Net",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-tower-broadcast",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "Erzeugung von WLAN-Voucher",
                        odAppSizeRow: "1",
                        odAppSizeCol: "1",
                        odAppLocation: "",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "50"
                    },
                    {
                        cn: "Nutzer",
                        dn: "cn=Nutzer,ou=core4five,ou=groups,dc=open-diakonie,dc=de",
                        description: "Allgemeine Nutzerrolle Core4Five",
                        odAppTitle: "RuDi#Core",
                        odAppType: "Link",
                        odAppIcon: "fa-light fa-heart-pulse",
                        odAppIconType: "font",
                        odAppSubTitle: "Raumveraltung für RuDi#BBB",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: 999
                    }
                ]
            },
            {
                cn: "odapp_grp_wissen",
                dn: "cn=odapp_grp_wissen,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Wissen",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "30",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "moodleuser",
                        dn: "cn=moodleuser,ou=lernraum,ou=groups,dc=open-diakonie,dc=de",
                        description: "Lernraum User allgemein. Wird auf jeden Fall benötigt",
                        odAppTitle: "Lernraum",
                        odAppType: "Link",
                        odAppIcon: "https://open-diakonie.de/cdn/images/lernraum_Symbol.svg",
                        odAppIconType: "file",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://lernraum.open-diakonie.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_wissen,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: 999
                    }
                ]
            },
            {
                cn: "odapp_grp_office",
                dn: "cn=odapp_grp_office,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Office",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "20",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "rcuser",
                        dn: "cn=rcuser,ou=rudicloud,ou=groups,dc=open-diakonie,dc=de",
                        description: "RuDi.Cloud allgemein Nutzer",
                        odAppTitle: "meineCloud",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-folder-open",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://meinecloud.open-diakonie.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_office,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: 999
                    },
                    {
                        cn: "odapp_meindienstplan",
                        dn: "cn=odapp_meindienstplan,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App mein Dienstplan",
                        odAppTitle: "mein Dienstplan",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-calendar-clock",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "Mit meinDienstplan haben Sie Zugang zur Zeitwirtschaft. Je nach Einrichtung können Sie hier ihre Dienstwünsche, Urlaubsanträge und Sollzeiten pflegen.",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://zeit.rummelsberger.net",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_office,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "10"
                    },
                    {
                        cn: "odapp_concludis",
                        dn: "cn=odapp_concludis,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App Concludis",
                        odAppTitle: "Bewerber<wbr>management",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-users-viewfinder",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "Zugriff auf concludis, das Bewerbermangement der Rummelsberger Diakonie",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://rummelsberger-diakonie.concludis.de/customer/",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_office,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "10"
                    }
                ]
            },
            {
                cn: "odapp_grp_rudoku",
                dn: "cn=odapp_grp_rudoku,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Rudoku",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "40",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "odapp_rudoku_cockpit",
                        dn: "cn=odapp_rudoku_cockpit,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App RuDoKu Klientencockpit",
                        odAppTitle: "Klientencockpit",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-address-card",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "Das Klientenkockpit ist eine App aus der RuDoKu Reihe",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://fiori.rummelsberger.net/z_flp#z_ish_dok01-klbase",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_rudoku,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "30"
                    }
                ]
            },
            {
                cn: "odapp_grp_bv",
                dn: "cn=odapp_grp_bv,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "Beantragungsverfahren",
                odAppType: "[group]",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "50",
                odAppCollapsed: false,
                odAppParent: "cn=odapp_grp_kommunikation,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                children: [
                    {
                        cn: "odapp_bv_auslagenerstattung",
                        dn: "cn=odapp_bv_auslagenerstattung,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App BV Auslagenerstattung",
                        odAppTitle: "Auslagenerstattung",
                        odAppType: "bv-link",
                        odAppIcon: "fa-light fa-circle-euro",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://fiori.rummelsberger.net/z_flp#z_bv-create?Antyp=RDMI&Atakt=01&Paket=AUSLA1",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_bv,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "40"
                    },
                    {
                        cn: "odapp_rd_merchandise",
                        dn: "cn=odapp_rd_merchandise,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App Merchandise",
                        odAppTitle: "Rummelsberger Merchandise",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-cart-shopping",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://rummelsberger.myspreadshop.de/",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_bv,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "100"
                    }
                ]
            },
            {
                cn: "odapp_grp_meineausbildung",
                dn: "cn=odapp_grp_meineausbildung,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                odAppTitle: "meineAusbildung",
                odAppType: "group",
                odAppIcon: "test",
                odAppIconType: "file",
                odAppSortOrder: "15",
                odAppCollapsed: false,
                children: [
                    {
                        cn: "odapp_rd_karriere",
                        dn: "cn=odapp_rd_karriere,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        description: "App Karriere",
                        odAppTitle: "Karriere",
                        odAppType: "link",
                        odAppIcon: "fa-light fa-person-rays",
                        odAppIconType: "font",
                        odAppSubTitle: "Rummelsberger Traumberufe",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://traumberufe-rummelsberger.de/berufseinsteiger#jobs",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_meineausbildung,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "100"
                    },
                    {
                        cn: "map_moodleuser",
                        dn: "cn=map_moodleuser,ou=moodle,ou=groups,dc=open-diakonie,dc=de",
                        description: "MeineAusbildung Moodle User",
                        odAppTitle: "Moodle",
                        odAppType: "Link",
                        odAppIcon: "fa-light fa-building-columns",
                        odAppIconType: "font",
                        odAppSubTitle: "",
                        odAppDescription: "",
                        odAppSizeRow: 1,
                        odAppSizeCol: 1,
                        odAppLocation: "https://moodle.open-diakonie.de",
                        odAppHelpLocation: "",
                        odAppParent: "cn=odapp_grp_meineausbildung,ou=ui,ou=groups,dc=open-diakonie,dc=de",
                        odAppSortOrder: "50"
                    }
                ]
            }
        ]
    }
};
export { appDataMockup };
